import { $host, $authHost, isDev } from './index'
import { httpPoint } from '../utils/const'


export const getAll = async (page, limit) => {
    const { data } = await $authHost.post(httpPoint.balance + 'getAll', {page, limit})
    return data
}

export const createOrder = async ({
    amount, paymentMethod
}) => {
    const { data } = await $authHost.post(httpPoint.balance + 'create', { amount, paymentMethod })
    return data
}